<div class="cf-flex-column cf-justify-content-center cf-align-items-center cf-fill">
  <mat-card appearance="outlined" aria-label="Login" class="login-card mat-elevation-z8">
    <mat-toolbar color="accent" class="header cf-flex-column cf-justify-content-space-between cf-align-items-center">
      <mat-toolbar-row class="cf-flex-row cf-justify-content-space-between cf-align-items-center">
        <h1 [translate]="'UI.Login'"></h1>
        <button [routerLink]="['/register']" mat-button class="register-button">
          <span [translate]="'UI.Register'"></span>
          <mat-icon aria-hidden="false" aria-label="Register arrow forward icon">arrow_forward</mat-icon>
        </button>
      </mat-toolbar-row>

      @if (isError) {
        <mat-toolbar-row class="error">
          <h2 [translate]="'UI.LoginFailed'"></h2>
        </mat-toolbar-row>
      }
    </mat-toolbar>
    <mat-card-content class="content">
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit(loginForm.value)">
        <mat-form-field class="form-field" appearance="outline" style="margin-top: 0.5em">
          <mat-label [translate]="'UI.Email'"></mat-label>
          <input type="email" matInput formControlName="email" aria-label="username" required autocomplete="username" />
          @if (email.invalid && (email.dirty || email.touched) && email.errors.email) {
            <mat-error [translate]="'UI.Error.InvalidEmail'"></mat-error>
          }
          @if (email.invalid && (email.dirty || email.touched) && email.errors.required) {
            <mat-error [translate]="'UI.Error.Required'"></mat-error>
          }
        </mat-form-field>
        <mat-form-field class="form-field" appearance="outline">
          <mat-label [translate]="'UI.Password'"></mat-label>
          <input type="password" matInput formControlName="password" aria-label="password" required autocomplete="current-password" />
          @if (password.invalid && (password.dirty || password.touched) && password.errors.required) {
            <mat-error [translate]="'UI.Error.Required'"></mat-error>
          }
        </mat-form-field>
        <button
          type="submit"
          mat-raised-button
          class="login-button primary-button"
          aria-label="login"
          [disabled]="!loginForm.valid || (isLoading$ | async)"
        >
          {{ 'UI.Login' | translate }}
        </button>
      </form>
    </mat-card-content>
    <mat-card-actions class="actions cf-flex-column">
      <div class="action-buttons cf-flex-row cf-justify-content-space-between cf-align-items-center">
        <button
          color="primary"
          mat-button
          aria-label="lost password"
          class="action-button"
          [disabled]="isLoading$ | async"
          [routerLink]="['/lostpassword']"
        >
          {{ 'UI.PasswordLost' | translate }}
        </button>
        <button
          color="primary"
          mat-button
          aria-label="haven't received email confirmation link"
          class="action-button"
          [disabled]="isLoading$ | async"
          [routerLink]="['/confirmemail']"
        >
          {{ 'UI.ConfirmEmail.NotReceived' | translate }}
        </button>
      </div>
    </mat-card-actions>
  </mat-card>
</div>
